export enum DashboardType {
  Operational = 'operational',
  Maintenance = 'maintenance',
  Management = 'management',
  Sensor = 'sensor',
  Strategic = 'strategic',
}

export const DASHBOARD_TYPE_VALUES = Object.values(DashboardType) as DashboardType[]

export const DEFAULT_DASHBOARD_TYPE = DashboardType.Operational
